import { FORTEM_URIS } from '@/constants/uris'
import { SalesLayout } from '@/pages/sales/layout'
import { PerfReportPage } from '@/pages/sales/perf-report/page'
import type { CustomRouteObject, FortemRouteHandle } from '@/router'

export const salesRoutes = [
  {
    path: FORTEM_URIS.SALES.__INDEX__,
    element: <SalesLayout />,
    handle: {
      title: 'Sales',
    },
    children: [
      {
        path: FORTEM_URIS.SALES.PERF_REPORT,
        element: <PerfReportPage />,
      },
    ],
  },
] satisfies CustomRouteObject<FortemRouteHandle>[]
